<template>
  <div style="background-color: #fff; height: 100%" class="home-css">
    <div style="background-color: #fff" :class="'store-head'">
      <div :class="'store-head-sub'">
        <div :class="'store-head-sub-div'">
          <img
              src="../assets/image/cluna/ic_welcome.png"
              alt=""/>
        </div>
        <p class="mr-1">حالت چطوره...!؟</p>
      </div>
      <div :class="'store-head-sub-2'">
        <p class="ml-1">How you feeling?</p>
        <div :class="'store-head-sub-div-2'">
          <img
              src="../assets/image/cluna/app_logo.png"
              alt=""/>
        </div>
      </div>
    </div>
    <div style="background-color: #c6c4c4" :class="'storeBody'">
      <div v-if="activeShowCategory === false">
        <div :class="'sliderStore-store'">
          <VueSlickCarousel
              v-bind="settings"
              v-if="dataBrand != undefined && dataBrand != null && dataBrand.length !== 0">
            <div
                :class="'imageSliderStore'"
                v-for="item in dataBrand"
                :key="item.index">
              <img
                  role="button" v-ripple @click="GoToBanner(item)"
                  :src="item.banner_cover"
                  :alt="item.banner_brief"/>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="mt-3" :class="'mediaSection'">
          <div class="mr-3 ml-3 mb-2 mt-5" :class="'titleMore'">
            <h5>همین حالا سفارش دهید!</h5>
          </div>
          <div class="d-flex flex-row overflow-y-auto pt-2 pb-5">
            <router-link :to="'/store-info?id='+ item.shop_id"
                         role="button" class="mr-2 ml-2" style="position: relative"
                         v-for="(item, index) in AllitemCat" :key="index">
              <div class="bdg-our-offer">
                <div class="shop_css" v-if="item.shop_delivery != false">
                  <v-icon>check</v-icon>
                  <p>پیک</p>
                </div>
              </div>
              <div class="mt-2 story-sub">
                <div class="itemStory">
                  <img :src="item.shop_cover" :alt="item.shop_name"/>
                </div>
                <div class="titleName">
                  <span class="font-weight-bold">{{ item.shop_name }}</span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="databanner != null && databanner.length > 0" :class="'mediaSection'">
          <div class="mr-3 mr-3 mb-2" :class="'titleMore'">
            <h5>امتحان کنید!</h5>
          </div>
          <div class="d-flex flex-column mb-5">
            <v-card role="button" v-ripple @click="$router.push({name: 'ProductInfo', query: {id: item.product_id}})"
                    :key="index" v-for="(item, index) in databanner"
                    class="mt-1 mr-3 ml-3 d-flex flex-column mb-3"
                    style="background-color: white; border-radius: 5px;">
              <img :src="item.product_special_image" class="center-cropped mb-2"
                   style="width: 100%; aspect-ratio: 16/9;"/>
              <span class="text-right mb-2 mr-2 ml-2"
                    style="font-size: 15px; color: black">{{ item.product_title }}</span>
              <span class="text-right mb-2 mr-2 ml-2"
                    style="font-size: 13px; color: darkslategray">{{ item.product_special_text }}</span>
            </v-card>
          </div>
        </div>
        <div v-if="dataproduct != null && dataproduct.length > 0" :class="'mediaSection'">
          <div class="mr-3 ml-3 mb-2" :class="'titleMore'">
            <h5>پیشنهاد ما به شما!</h5>
          </div>
          <div class="d-flex flex-row overflow-y-auto">
            <div role="button" v-ripple @click="$router.push({name: 'ProductInfo', query: {id: item.product_id}})"
                 :key="index" v-for="(item, index) in dataproduct"
                 class="mt-1 mr-2 ml-2 d-flex flex-column mb-3">
              <img :src="item.product_icon" class="center-cropped mb-2 mr-auto ml-auto"
                   style="width: 80px; height: 80px; border-radius: 100%;"/>
              <span class="text-center mb-2 mr-auto ml-auto"
                    style="font-size: 13px; color: white; width: 120px;">{{ item.product_title }}</span>
              <span class="text-center mb-2 mr-auto ml-auto"
                    style="font-size: 14px; color: black; width: 100px;">
                                {{ oracle.format(item.product_sell_price) + ' تومان' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 250px;  background-color: #c6c4c4;"></div>
    </div>
    <div :class="'contact-us'" v-if="oracle.getToken() == null">
      <v-btn role="button" v-ripple @click="$router.push('/profile?login=true')">
        به ما بپیوندید
      </v-btn>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import oracle from "@/utils/oracle";

export default {
  name: "Home",
  components: {VueSlickCarousel},
  data() {
    return {
      AllitemCat: [],
      oracle: oracle,
      databanner: [],
      dataproduct: [],
      dataBrand: [],
      activeShowCategory: false,
      settings: {
        arrows: false,
        dots: true,
        autoplay: true,
        rtl: false,
      },
    };
  },
  methods: {
    showStory(id) {
      this.$router.push({"name": 'StoreInfo', "query": {"id": id}})
    },
  },
  mounted() {
    oracle.axios(
        "shop/getList",
        {"limit_by": 500, "offset_by": 0, "order_by": "priority"},
        (res) => {
          this.AllitemCat = res.data.reverse()
        }
    );
    oracle.axios(
        "banner/getList",
        {"limit_by": 500, "offset_by": 0, "order_by": "priority"},
        (res) => {
          this.dataBrand = res.data;
        }
    );
    oracle.axios(
        "product/getList",
        {
          offset_by: 0,
          limit_by: 1000,
          order_by: "priority",
          filter_by: true,
        }, (response) => {
          this.databanner = []
          this.dataproduct = []
          let AllData = response.data;
          for (let i = 0; i < AllData.length; i++) {
            if (AllData[i].product_special == true) {
              let exist = false
              for (let j = 0; j < this.databanner.length; j++) {
                if (this.databanner[j].product_id == AllData[i].product_id) {
                  exist = true
                  break
                }
              }
              if (!exist) {
                this.databanner.push(AllData[i]);
              }
            }
          }
          for (let i = 0; i < AllData.length; i++) {
            if (AllData[i].product_trend == true) {
              let exist = false
              for (let j = 0; j < this.dataproduct.length; j++) {
                if (this.dataproduct[j].product_id == AllData[i].product_id) {
                  exist = true
                  break
                }
              }
              if (!exist) {
                this.dataproduct.push(AllData[i]);
              }
            }
          }
        }
    );
  },
};
</script>
<style>
.home-css {
  width: 100%;
  background-color: #ddd8d8;
  height: 100%;
}

.home-css .box-modal {
  padding: 10px 15px;
}

.home-css .box-modal input::placeholder {
  font-size: 12px;
}

.home-css .headline-tv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.home-css .headline-tv span {
  font-size: 12px !important;
  font-weight: bold;
}

.home-css .store-head {
  background-color: white;
  display: flex;
  position: sticky;
  top: 0;
  z-index: 500;
  justify-content: space-between;
  padding: 10px
}

.home-css .store-head-sub {
  display: flex;
  justify-content: right;
  width: 50%
}

.home-css .store-head-sub p {
  color: black;
  direction: ltr;
  font-size: 10px;
  margin-top: 19px;
  margin-bottom: 0
}

.home-css .store-head-sub-2 {
  display: flex;
  justify-content: left;
  width: 50%
}

.home-css .store-head-sub-2 p {
  color: black;
  direction: ltr;
  font-size: 10px;
  margin-top: 21px;
  margin-bottom: 0
}

.home-css .store-head-sub-div {
  width: 12%
}

.home-css .store-head-sub-div img {
  width: 100% !important;
  height: auto
}

.home-css .store-head-sub-div-2 {
  width: 22%
}

.home-css .store-head-sub-div-2 img {
  width: 100% !important;
  height: auto
}

.home-css .contact-us {
  text-align: left;
}

.home-css .contact-us button {
  margin-bottom: 80px;
  position: fixed;
  bottom: 0;
  left: 25px;
  border-radius: 20px;
  background-color: #7ec352 !important;
  color: white !important;
}

.home-css .mediaSection {
  padding: 10px 0;
  margin: 15px 0;
}

.home-css .titleMore {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}

.home-css .titleMore h5 {
  font-size: 14px;
  font-weight: bold;
}

.home-css .main-story {
  display: flex;
  flex-wrap: nowrap;
  width: 110%;
  overflow: auto;
  direction: ltr;
}

.home-css .itemStory {
  width: 80px;
  height: 80px;
  border-radius: 120px;
  /*background: #ffdb02;*/
  /*border: 2px solid #ffdb02;*/
  overflow: hidden;
  position: relative;
}

.home-css .itemStory img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-css .shop_css {
  background-color: #2ab0f7;
  width: auto;
  height: 25px;
  border-radius: 45%;
  display: flex !important;
  color: white;
  font-size: 10px;
  padding: 3px !important;
  margin: 0 !important;
  align-content: center;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.home-css .shop_css i {
  font-size: 12px;
  margin-right: 10px;
  color: white !important;
}

.home-css .shop_css p {
  text-align: center;
  margin-bottom: 0 !important;
  margin-left: 10px;
  margin-right: 2px;
}

.home-css .bdg-our-offer {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
}

.home-css .titleName {
  text-align: center;
  font-size: 13px;
  margin-top: 10px;
  color: white;
}

.home-css .selectedBradn {
  border-color: #ffdb02 !important;
}

.home-css .delpriceitem del {
  color: #7ec352;
  font-weight: bold;
}

.home-css .sliderStore-store .slick-dots {
  bottom: -15px !important;
}

.home-css .sliderStore-store .slick-dots li {
  width: 10px;
}

.home-css .sliderStore-store .slick-dots li.slick-active button:before {
  width: 10px;
  background: #ffdb02 !important;
}

.home-css .sliderStore-store .slick-dots li button {
  position: absolute;
  top: -36px;
}

.home-css .isSelected {
  background: #fff !important;
  color: #7ec352 !important;
}

.home-css .btn_Brands {
  display: flex;
  align-items: center;
  padding: 10px 0;
  overflow: auto;
}

.home-css .removeFilter span,
.home-css .removeFilter .v-icon {
  color: red !important;
}

.home-css .category_filter h6 {
  text-align: right;
  padding: 10px 15px;
}

.home-css .category_filter {
  margin: 10px 15px;
  display: flex;
  flex-direction: column;
}

.home-css .headlineSetting {
  display: flex;
  justify-content: space-between;
}

.home-css .btn_Filter .v-btn {
  color: #fff;
  width: 90%;
}

.home-css .sliderStore-store::before {
  transform: translateZ(-1px) scale(2);
  z-index: -1;
}

.home-css .imageSliderStore {
  width: 100% !important;
  height: calc(9 * 100vw / 16);
  /*max-width: 100vw;*/
  /*max-height: calc(9 / 16 * 100vw);*/
  /*width: calc(16 / 9 * 100vh) !important;*/
  /*border-radius: 10px;*/
  overflow: hidden;
}

.home-css .imageSliderStore a {
  display: flex;
}

.home-css .imageSliderStore img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-css .slick-slide {
  height: unset !important;
}

.home-css .sliderBox .slick-slide > div {
  height: auto;
}

.home-css .slick-dots li button:before {
  color: #fff !important;
  border: 1px solid #1e405e;
  border-radius: 50%;
  width: 20px !important;
  height: 20px !important;
  font-size: 6px;
  position: relative;
  overflow: hidden;
}

.home-css .image-slide-product a {
  text-decoration: none;
  color: #000;
  background-color: #fff;
  display: block;
}

.home-css .storeBody {
  /*overflow: scroll;*/
  /*margin: 0 0 80px;*/
  perspective: 1px;
  transform-style: preserve-3d;
  background-color: #c6c4c4;
}

.home-css .storeBody::-webkit-scrollbar {
  width: 5px;
}

.home-css .storeBody::-webkit-scrollbar-track {
  border-radius: 3px;
}

.home-css .storeBody::-webkit-scrollbar-thumb {
  background: #c6c4c4;
  border-radius: 3px;
}

.home-css .storeBody::-webkit-scrollbar-thumb:hover {
  background: #c6c4c4;
}

.home-css .headlineSetting {
  display: flex;
  justify-content: space-between;
}

.home-css .removeFilter span,
.home-css .removeFilter .v-icon {
  color: red !important;
}

.home-css .btn_Filter .v-btn {
  color: #fff;
  width: 90%;
}

.home-css .category_filter h6 {
  text-align: right;
  padding: 10px 15px;
}

.home-css .category_filter {
  margin: 10px 15px;
  display: flex;
  flex-direction: column;
}

.home-css .btn_Brands {
  display: flex;
  align-items: center;
  padding: 10px 0;
  overflow: auto;
}

.home-css .categoryItem {
  border-radius: 100px;
  height: 30px;
  padding: 10px 0;
  margin: 0 10px;
  color: #707070;
  background: #dbdcdd;
  font-size: 12px;
  display: flex;
  align-items: center;
  direction: ltr;
  min-width: 100px;
  justify-content: center;
}

.home-css .btn-Brand {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #e0e0e0;
}

.home-css .btn-Brand img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.home-css .store {
}

.home-css .btnCategory {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
}

</style>
